import React, { useEffect } from "react";
import { Button, Stack } from "@mui/material";
import UserSetting from "../../../../../components/common/layout/header/UserSetting";
import { MenuItemType } from "../../../../../types/menu.type";
import { LuBuilding2, LuFile, LuHome, LuStore, LuUser } from "react-icons/lu";
import SelectApiInput from "../../../../../components/common/input/SelectApiInput";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentStore } from "../../../../../redux/reducers/config.reducer";

interface IHeader {
  height: string;
}

const options: MenuItemType[] = [
  {
    path: "/",
    text: "Trang chủ",
    Icon: LuHome,
  },
  {
    path: "/list/hd_nh",
    text: "Đơn hàng",
    Icon: LuFile,
  },
  {
    path: "/list/customer",
    text: "Khách hàng",
    Icon: LuUser,
  },
  {
    path: "/app",
    text: "Danh sách công ty",
    Icon: LuBuilding2,
  },
];

function Header({ height }: IHeader) {
  const currentStore = useSelector((state: any) => state.config.currentStore);
  const dispatch = useDispatch();

  const handleStoreChange = (store: any) => {
    dispatch(updateCurrentStore(store));
  };

  useEffect(() => {
    if (!currentStore) {
      const displayStore = document.getElementById("display-store");
      displayStore?.click();
    }
  }, [currentStore]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: "100%", height, px: 2, backgroundColor: "background.paper" }}
    >
      <div></div>
      <Stack direction="row" alignItems="center" gap={1}>
        <SelectApiInput
          forceOpenSelect={!currentStore}
          selectTitle="Chọn chi nhánh"
          wrapperSx={{ width: "120px", height: "42px" }}
          apiCode="dmkho"
          searchFields={["ma_kho", "ten_kho"]}
          getOptionLabel={(option) => option.ten_kho}
          checkEqual={(value, option) => value?.ma_kho === option?.ma_kho}
          value={currentStore}
          onChange={handleStoreChange}
          renderDisplay={({ value, onClick }) => {
            return (
              <Button
                id="display-store"
                size="small"
                variant="contained"
                onClick={onClick}
                sx={{
                  backgroundColor: "background.default",
                  color: "text.primary",
                  textTransform: "none",
                  fontWeight: 400,
                  boxShadow: "none",
                  height: "34px",
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
                startIcon={<LuStore size={16} />}
              >
                {value?.ten_kho || "Chọn chi nhánh"}
              </Button>
            );
          }}
        />
        <UserSetting options={options} />
      </Stack>
    </Stack>
  );
}

export default Header;
